import { FieldTypes } from './FieldTypes'

export const ARRAY_ERROR = 'FINAL_FORM/array-error'
export const fieldTypeNames: Record<FieldTypes, string> = {
  [FieldTypes.TEXT]: 'Text',
  [FieldTypes.HEIGHT]: 'Height',
  [FieldTypes.TEXTAREA]: 'Text (multiline)',
  [FieldTypes.NUMBER]: 'Number',
  [FieldTypes.BOOLEAN]: 'Yes/No',
  [FieldTypes.DATE]: 'Date',
  [FieldTypes.TIME]: 'Time',
  [FieldTypes.DATETIME]: 'DateTime',
  [FieldTypes.DROPDOWN]: 'Dropdown',
  [FieldTypes.CHECKBOX]: 'Checkbox',
  [FieldTypes.ALTERNATE]: 'Alternate',
  [FieldTypes.MULTIPLE_SELECT]: 'Multiple Select',
  [FieldTypes.DOLLAR_AMOUNT]: 'Dollar Amount',
  [FieldTypes.EMAIL]: 'Email',
  [FieldTypes.PHONE]: 'Phone',
  [FieldTypes.FILE]: 'File',
  [FieldTypes.ID]: 'Database Item',
  [FieldTypes.DYNAMIC_DROPDOWN]: 'Database Item Property',
  [FieldTypes.PERCENTAGE]: 'Percentage',
  [FieldTypes.SIGNATURE]: 'Signature',
  [FieldTypes.INITIALS]: 'Initials',
  [FieldTypes.EXAM_SECTION]: 'Exam Section',
  [FieldTypes.BLOOD_PRESSURE]: 'Blood Pressure',
}
